
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/privacy",
      function () {
        return require("private-next-pages/en/privacy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/privacy"])
      });
    }
  